import { type FunctionComponent, memo, type ReactNode } from 'react';
// Material UI imports
import { AdapterLuxon } from '@mui/x-date-pickers/AdapterLuxon';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
// local imports
import { AnalyticsProvider } from './analytics';
import { GlobalProvider } from './global';
import { DataProvider } from './index';
import { SupervisorProvider } from './supervisor';
import { PersistentProvider } from './persistent';
import ApolloContext from './ApolloContext';

type ContextProvidersProps = {
  readonly children?: ReactNode;
};

const ContextProviders: FunctionComponent<ContextProvidersProps> = ({
  children
}) => (
  <AnalyticsProvider>
    <GlobalProvider>
      <DataProvider>
        <SupervisorProvider>
          <PersistentProvider>
            <LocalizationProvider dateAdapter={AdapterLuxon}>
              <ApolloContext>
                {children}
              </ApolloContext>
            </LocalizationProvider>
          </PersistentProvider>
        </SupervisorProvider>
      </DataProvider>
    </GlobalProvider>
  </AnalyticsProvider>
);

export default memo(ContextProviders);
